import axios from 'axios';
import BaseAPI from './base-api';
import RequiredDocuments_ from './models/RequiredDocumet';

export default class DocAPI extends BaseAPI {
  static getRequiredDocuments() {
    return BaseAPI.promiseWrapper<RequiredDocuments_[]>(axios({
      method: 'GET',
      url: `${window.feHost}/api/Documents/GetAllRequests`,
      headers: BaseAPI.getRequestHeaders(),
    }));
  }

  static getRequiredDocumentsHistory() {
    return BaseAPI.promiseWrapper<RequiredDocuments_[]>(axios({
      method: 'GET',
      url: `${window.feHost}/api/Documents/GetHistory`,
      headers: BaseAPI.getRequestHeaders(),
    }));
  }

  static getAllRequestsCount() {
    return BaseAPI.performPlat(axios({
      url: `${window.feHost}/api/Documents/GetAllRequestsCount`,
      headers: BaseAPI.getRequestHeaders(),
    }));
  }

  static submitFile(bodyFormData) {
    return BaseAPI.promiseWrapper(axios({
      method: 'POST',
      url: `${window.feHost}/api/Documents/SubmitFile`,
      data: bodyFormData,
      headers: BaseAPI.getRequestHeaders(),
    }));
  }

  static submit(docGuid: string) {
    return BaseAPI.promiseWrapper<void>(axios({
      method: 'POST',
      url: `${window.feHost}/api/Documents/SubmitFiles`,
      data: { docGuid, },
      headers: BaseAPI.getRequestHeaders(),
    }));
  }

  static uploadFile(bodyFormData) {
    return BaseAPI.promiseWrapper(axios({
      method: 'POST',
      url: `${window.feHost}/api/Documents/UploadFile`,
      data: bodyFormData,
      headers: { ...BaseAPI.getRequestHeaders(), 'Content-Type': 'multipart/form-data', },
    }));
  }

  static removeFile(attachmentGuid:string, docGuid: string) {
    return BaseAPI.promiseWrapper(axios({
      method: 'POST',
      url: `${window.feHost}/api/Documents/RemoveFile`,
      data: { docGuid, attachmentGuid, },
      headers: BaseAPI.getRequestHeaders(),
    }));
  }
}
